import { useId } from 'react'

// Kontext-Hilfe: Info-Icon mit Hover-/Fokus-Tooltip (rein CSS positioniert, per aria-describedby verknüpft;
// Styles: .wf-tip in styles.css — auf Touch erscheint das Panel als fixes Blatt am unteren Rand).
// Extrahiert aus der Rechte-Matrix (13.07.), wiederverwendet u. a. in der Betreiber-Übersicht.

/** Lucide „info“ (inline statt Dependency — harte CSP, kein CDN; aria-hidden, der Button trägt das Label). */
function InfoIcon() {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
  )
}

export interface TipLine {
  label: string
  text: string
  warn?: boolean
}

/** Info-Icon + Tooltip: Titel, ein Zweck-Satz und optional erklärte Einzelwerte (z. B. Stufen/Status). */
export function InfoTip({ title, purpose, lines }: { title: string; purpose: string; lines?: TipLine[] }) {
  const tipId = useId()
  return (
    <span className="wf-tip">
      <button type="button" className="wf-tip__btn" aria-label={`Erklärung zu „${title}“`} aria-describedby={tipId}>
        <InfoIcon />
      </button>
      <span className="wf-tip__panel" role="tooltip" id={tipId}>
        <span className="wf-tip__title">{title}</span>
        <span className="wf-tip__purpose">{purpose}</span>
        {lines?.map((l) => (
          <span key={l.label} className={`wf-tip__line${l.warn ? ' wf-tip__line--warn' : ''}`}>
            <b>{l.warn ? '⚠️ ' : ''}{l.label}:</b> {l.text}
          </span>
        ))}
      </span>
    </span>
  )
}
